import { type PropsWithChildren } from 'react';
import { RouterProvider } from '@direct-frontend/components';
import { HistoryRouter, type HistoryRouterProps } from '@direct-frontend/modules-router/client';
import { setI18nLang } from '@adv-frontend/l10n';
import { createRumHistory, initErrorBooster, initRum } from '@adv-frontend/yastore-modules/lib';
import { getRequestContext } from '#shared/lib/context';
import { getErrorBoosterInitConfig, subscribeToErrorBoosterPageChanges } from '#shared/lib/errorBooster';
import { initClientPlatform } from '#shared/lib/platform';
import { useNavigateWithSearchParams } from '#shared/lib/router';
import { getRumInitConfig } from '#shared/lib/rum';
import { init as initContext } from '../context';

type AppHistory = ReturnType<typeof createRumHistory>;

let historyInstance: AppHistory | undefined;

function getHistory(): AppHistory {
    if (historyInstance === undefined) {
        historyInstance = createRumHistory();
    }

    return historyInstance;
}

/**
 * Провайдер контекста роутера на клиенте
 * @kind component
 */
export function Router(props: Omit<HistoryRouterProps, 'history'>) {
    const { children, ...historyRouterProps } = props;

    return (
        <HistoryRouter {...historyRouterProps} history={getHistory()}>
            <RouterNavigateProvider>{children}</RouterNavigateProvider>
        </HistoryRouter>
    );
}

/*
 * Предоставляет методы навигации для библиотеки компонентов
 */
function RouterNavigateProvider(props: PropsWithChildren) {
    const navigate = useNavigateWithSearchParams();

    return <RouterProvider navigate={navigate}>{props.children}</RouterProvider>;
}

export const initClient = () => {
    initContext();
    initClientPlatform();

    setI18nLang('ru');

    const isDevelopment = getRequestContext().env === 'development';

    if (!isDevelopment) {
        initRum(getRumInitConfig());
        initErrorBooster(getErrorBoosterInitConfig(window.location.pathname));
        subscribeToErrorBoosterPageChanges(getHistory());
    }
};
